"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.reducerSweetAlert = void 0;
const constants_1 = require("../constants");
const stateDefault = {
    show: false,
    title: '',
};
const reducerSweetAlert = (state = stateDefault, action) => {
    switch (action.type) {
        case constants_1.SWEET_ALERT_SHOW:
            return Object.assign(Object.assign({}, stateDefault), action.payload);
        case constants_1.SWEET_ALERT_UPDATE:
            return Object.assign(Object.assign({}, state), action.payload);
        case constants_1.SWEET_ALERT_HIDE:
            return Object.assign(Object.assign({}, state), action.payload);
        case constants_1.SWEET_ALERT_HIDE_COMPLETE:
            return Object.assign({}, stateDefault);
        default:
            return state;
    }
};
exports.reducerSweetAlert = reducerSweetAlert;
